<div class="geopoint-widget">
    <div class="row mb-2">
        <div class="col-6">
            <label class="small text-muted">Latitude
                <svg (click)="onHistoryLat.emit()" class="geopoint-history-btn pointer ml-1"
                     ngbTooltip="Historique Latitude"
                     style="width: 0.9rem; height: 0.9rem;" fill="none"
                     stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </label>
            <input type="text"
                   class="form-control form-control-sm"
                   [class.is-invalid]="latError"
                   [value]="latDisplay"
                   [disabled]="disabled"
                   (blur)="onLatChange($event.target.value)"
                   placeholder="-90.000000 / 90.000000">
            <div class="invalid-feedback" *ngIf="latError">{{ latError }}</div>
        </div>
        <div class="col-6">
            <label class="small text-muted">Longitude
                <svg (click)="onHistoryLng.emit()" class="geopoint-history-btn pointer ml-1"
                     ngbTooltip="Historique Longitude"
                     style="width: 0.9rem; height: 0.9rem;" fill="none"
                     stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </label>
            <input type="text"
                   class="form-control form-control-sm"
                   [class.is-invalid]="lngError"
                   [value]="lngDisplay"
                   [disabled]="disabled"
                   (blur)="onLngChange($event.target.value)"
                   placeholder="-180.000000 / 180.000000">
            <div class="invalid-feedback" *ngIf="lngError">{{ lngError }}</div>
        </div>
    </div>
    <div class="geopoint-map" #mapContainer></div>
</div>
